<template>
  <b-card class="bg-transparent border-0">
    <div class="row">
      <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
        <b-form-group :label="$t('logs.filtro.usuario')" label-for="filter-user">
          <b-input id="filter-user" v-model="filtro.user"/>
        </b-form-group>
      </form>

      <b-form-group :label="$t('logs.filtro.periodo_padrao')" class="col-md-3">
        <b-select id="period-default" @change="selectPeriod" v-model="periodo.padrao.model">
          <b-form-select-option v-for="(periodo, k) in periodo.padrao.options" :key="k" :value="periodo">
            {{ periodo.label }}
          </b-form-select-option>
        </b-select>
      </b-form-group>
      <div class="col-md-3 d-flex align-items-center">
        <b-button id="btn-collapse-filters"
                  variant="link border-primary mt-3"
                  :title="$t('logs.filtro.mais_filtros')"
                  v-b-toggle.collapse-filters
                  v-b-tooltip
                  pill>
          <i class="fas fa-plus"/>
        </b-button>
      </div>
      <CountDown class="col-md-3 justify-content-center" @time-over="selectPeriod(periodo.padrao.model)"
                 @refresh="selectPeriod(periodo.padrao.model)"/>
    </div>

    <b-collapse id="collapse-filters" class="mt-2" v-model="filtro.show">
      <div class="row">
        <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
          <b-form-group :label="$t('logs.filtro.veus_id')" label-for="filter-veus-id">
            <b-input id="filter-veus-id" v-model="filtro.veus_id"/>
          </b-form-group>
        </form>
        <b-form-group :label="$t('logs.filtro.periodo_personalizado')" class="col-md-3">
          <DatePicker id="period-custom" v-model="periodo.datepicker.model" @change="selectDatepicker" range/>
        </b-form-group>
        <b-form-group v-if="isVEUS" :label="$t('logs.filtro.evento')"
                      label-for="filter-event" class="col-md-3">
          <v-select
              id="filter-event"
              class="w-100"
              @input="e => setEvent('event', e)"
              :options="eventsOptions"
          />
        </b-form-group>
      </div>
      <div class="row">
        <form class="col-md-3" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
          <b-form-group :label="$t('logs.filtro.modelo')" label-for="filter-model">
            <b-input id="filter-model" v-model="filtro.model"/>
          </b-form-group>
        </form>
        <form class="col-md-6" @submit="e => {e.preventDefault(); resetPaginator(); $emit('search')}">
          <b-form-group :label="$t('logs.filtro.chave_modelo')" label-for="filter-modelo-id">
            <b-input id="filter-model-id" v-model="filtro.model_id"/>
          </b-form-group>
        </form>
        <div class="col-md-3 d-flex" />
      </div>
      <div class="row">
        <div class="col-md-3">
          <b-btn variant="link" class="align-self-center mt-3 btn-block" @click="cleanFilters">
            <i class="fas fa-search-minus"/> {{ $t('logs.filtro.limpar_button') }}
          </b-btn>
        </div>
        <div class="col-md-6">
          <b-btn id="btn-filter"
                 variant="primary"
                 class="align-self-center mt-3 btn-block"
                 @click="resetPaginator();
                 $emit('search')">
            <i class="fas fa-search"/> {{ $t('logs.filtro.filtrar_button') }}
          </b-btn>
        </div>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import {hasPerfil} from '@/acl'
import CountDown from "@/components/CountDown";
import moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import {mapActions, mapGetters} from "vuex";

export default {
  name: "LogFilter",
  components: {
    CountDown,
    DatePicker
  },
  computed: {
    ...mapGetters({
      filtro: 'logFilter/all'
    }),
    eventsOptions() {
      return [
        {label: 'created', value: 'created'},
        {label: 'updated', value: 'updated'},
        {label: 'deleted', value: 'deleted'},
      ]
    }
  },
  data() {
    return {
      isVEUS: false,
      periodo: {
        padrao: {
          model: {
            label: this.$t('logs.periodos.hoje'),
            amount: {start_date: 0, end_date: 0},
            unit: {start_date: 'minutes', end_date: 'minutes'},
            unitOfTime: {start_date: 'day', end_date: 'day'}
          },
          options: [
            {
              label: this.$t('logs.periodos.hoje'),
              amount: {start_date: 0, end_date: 0},
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {start_date: 'day', end_date: 'day'}
            },
            {
              label: this.$t('logs.periodos.sete_dias'),
              amount: {start_date: 7, end_date: 0},
              unit: {start_date: 'days', end_date: 'minutes'},
              unitOfTime: {start_date: 'day', end_date: 'day'}
            }, {
              label: this.$t('logs.periodos.mes_atual'),
              amount: {
                start_date: 0,
                end_date: 0
              },
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {
                start_date: 'month',
                end_date: 'month'
              }
            }, {
              label: this.$t('logs.periodos.mes_anterior'),
              amount: {start_date: 1, end_date: 1},
              unit: {start_date: 'month', end_date: 'month'},
              unitOfTime: {start_date: 'month', end_date: 'month'}
            }, {
              label: this.$t('logs.periodos.ano_atual'),
              amount: {start_date: 0, end_date: 0},
              unit: {start_date: 'minutes', end_date: 'minutes'},
              unitOfTime: {start_date: 'year', end_date: 'year'}
            }, {
              label: this.$t('logs.periodos.ano_anterior'),
              amount: {start_date: 1, end_date: 1},
              unit: {start_date: 'years', end_date: 'years'},
              unitOfTime: {start_date: 'year', end_date: 'year'}
            }
          ]
        },
        datepicker: {model: null}
      }
    }
  },
  methods: {
    ...mapActions([
      'logFilter/setSpecific',
      'logFilter/reset',
      'order/setPagination'
    ]),
    setEvent(key, event) {
      let eventValue = null
      if (event){
        eventValue = event.value
      }
     this['logFilter/setSpecific']({[key]: eventValue})
     this.resetPaginator()
     this.$emit('search')
    },
    selectPeriod(period) {
      let start_date = moment().subtract(period.amount.start_date, period.unit.start_date)
      let end_date = moment().subtract(period.amount.end_date, period.unit.end_date)

      if (period.unitOfTime.start_date) {
        start_date = start_date.startOf(period.unitOfTime.start_date).format()
      }
      if (period.unitOfTime.end_date) {
        end_date = end_date.endOf(period.unitOfTime.end_date).format()
      }

      this['logFilter/setSpecific']({start_date})
      this['logFilter/setSpecific']({end_date})
      this.resetPaginator()
      this.$emit('search')
    },
    selectDatepicker(period) {
      if (period.length > 0) {
        period[0].setHours(0, 0, 0, 0)
        period[1].setHours(23, 59, 59, 999)
      }
      const start_date = moment(period[0].toUTCString()).tz("America/Sao_Paulo").format()
      const end_date = moment(period[1].toUTCString()).tz("America/Sao_Paulo").format()
      this['logFilter/setSpecific']({start_date})
      this['logFilter/setSpecific']({end_date})
      this.resetPaginator()
      this.$emit('search')
    },
    resetPaginator() {
      this['order/setPagination']({
        page: 1,
        per_page: 10,
        total: 0
      })
    },
    cleanFilters() {
      this['logFilter/reset']()
      this.resetPaginator()
      this.$emit('search')
    },
    async hasPerfil(perfil) {
      try {
        return await hasPerfil(perfil)
      } catch (e) {
        return false
      }
    }
  },
  async mounted() {
    this.isVEUS = await hasPerfil('root')
  }
}
</script>

<style lang="scss" scoped>
/deep/ .mx-datepicker {
  width: 100%;
}
#collapse-filters{
  @media (max-width: 600px) {
    margin-left: 2rem!important;
    margin-right: 2rem!important;
    .ml-5, .mr-5{
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
}
</style>
